export default "__VITE_ASSET__29c3148f__"